import { Action, createReducer, on } from '@ngrx/store';
import { AlertResponse } from '@shared/widgets/entities/alerts';
import {
  loadAlertSuccessAction, deleteAlertSuccessAction,
  createAlertSuccessAction, resetWidgetDataAction
} from '@shared/widgets/store/actions/alerts.action';

export const initialState = {} as AlertResponse;

const featureReducer = createReducer(
  initialState,
  on(loadAlertSuccessAction, (state, { data }) => data ? data : state),
  on(createAlertSuccessAction, (state, { response }) => response ? response : state),
  on(
    deleteAlertSuccessAction,
    resetWidgetDataAction,
    () => initialState
  ),
);

export const alertReducer = (state: AlertResponse, action: Action): AlertResponse => {
  return featureReducer(state, action);
};
